(function () {
  const BADGE_SELECTOR = '.price__badge-sale';
  const REGULAR_SELECTOR = '.price__sale .price-item--regular';
  const SALE_SELECTOR = '.price__sale .price-item--sale';

  function parseMoney(text) {
    if (!text) return NaN;
    const cleaned = text.replace(/[^0-9.,-]/g, '').replace(/,(?=\d{3}\b)/g, '');
    return parseFloat(cleaned.replace(/,/g, '.'));
  }

  function computeBadgeText(priceEl) {
    const regularEl = priceEl.querySelector(REGULAR_SELECTOR);
    const saleEl = priceEl.querySelector(SALE_SELECTOR);
    if (!regularEl || !saleEl) return null;
    const regular = parseMoney(regularEl.textContent);
    const sale = parseMoney(saleEl.textContent);
    if (!isFinite(regular) || !isFinite(sale) || regular <= 0) return null;
    if (sale >= regular) return '';
    const percent = Math.round(((regular - sale) / regular) * 100);
    return percent + '% Off';
  }

  function observe(priceEl) {
    if (priceEl.dataset.badgeSyncBound === '1') return;
    if (!priceEl.querySelector(BADGE_SELECTOR)) return;
    priceEl.dataset.badgeSyncBound = '1';

    let observer;
    function sync() {
      const badge = priceEl.querySelector(BADGE_SELECTOR);
      if (!badge) return;

      const next = computeBadgeText(priceEl);
      if (next === null) return;

      if (next === '') {
        if (badge.style.display !== 'none') {
          observer.disconnect();
          badge.style.display = 'none';
          observer.observe(priceEl, observerConfig);
        }
        return;
      }

      const needsDisplayReset = badge.style.display === 'none';
      if (badge.textContent.trim() === next && !needsDisplayReset) return;

      observer.disconnect();
      if (needsDisplayReset) badge.style.display = '';
      badge.textContent = next;
      observer.observe(priceEl, observerConfig);
    }

    const observerConfig = {
      childList: true,
      subtree: true,
      characterData: true,
    };
    observer = new MutationObserver(sync);
    observer.observe(priceEl, observerConfig);
    sync();
  }

  function init() {
    document.querySelectorAll('.price--on-sale').forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
